import { doPost, doPost2WithFormData } from './common'

const sendCcpaInfoToEmail = () => {
  return doPost(`/user/sendCcpaMail`)
}

// doPost2WithFormData resolves with the raw Response — it doesn't throw on a
// non-2xx status, so check response.ok before trusting the body.
const requestUserDataExport = async ({ email, token, tokenSource }) => {
  const response = await doPost2WithFormData(`/user/data-export-request`, {
    email,
    token,
    tokenSource,
  })
  if (!response.ok) {
    throw new Error(response.status)
  }
  return response.json()
}

export { sendCcpaInfoToEmail, requestUserDataExport }
